<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
name: "NotifikacijaBase"
}
</script>

<style scoped>

</style>